import useEvent from "react-use-event-hook";

export const useSaveAs = () => {
  const saveAs = useEvent(
    (data, fileName, mimeType = "application/octet-stream") => {
      // Create a Blob from the data
      const blob = new Blob([data], { type: mimeType });

      // Create an anchor element to trigger the download
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName;

      // Programmatically click the link to trigger the download
      link.click();

      // Clean up the object URL after the download
      URL.revokeObjectURL(link.href);
    },
  );

  return { saveAs };
};
